export class BodyUtility {
    ToggleScroll() {
        if (!$('html').hasClass('ax-noscroll')) {
            this.DisableScroll();
            return;
        }
        this.EnableScroll();
    }

    EnableScroll() {
        let scrollTop = parseInt($('html').css('top'));
        $('html').removeClass('ax-noscroll');
        $('html,body').scrollTop(-scrollTop);
    }

    DisableScroll() {
        if ($(document).height() > $(window).height()) {
            let scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
            $('html').addClass('ax-noscroll').css('top', -scrollTop);
        }
    }

    enableOverlay() {
        let scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
        $('html').addClass('ax-noscroll').css('top', -scrollTop);
    }

    disableOverlay() {
        let scrollTop = parseInt($('html').css('top'));
        $('html').removeClass('ax-noscroll');
        $('html,body').scrollTop(-scrollTop);
    }
}